// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.files__HJIGD {
  margin: 8px 0 20px;
  padding: 0 20px;
  color: #262732;
}

.filesTitle__oFUgb {
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
}

.fileLinkWrapper__cRpQe {
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 8px;
  padding: 8px 16px;

  text-decoration: none;

  background: #EDEFF3;
  border-radius: 8px;
}

.fileLinkWrapper__cRpQe:hover {
  background: #E5E7F1;
}

.fileLinkWrapper__cRpQe:active {
  background: #DADFF1;
}

.fileLinkWrapper__cRpQe img {
  width: 16px;
  height: 16px;
}

.file__TtIaQ {
  display: flex;
  gap: 4px;
}

.fileName__PWkJl, .fileSize__NiUsy {
  font-size: 13px;
}

.fileName__PWkJl {
  color: #262732;
}

.fileSize__NiUsy {
  min-width: fit-content;
  color: #A7B1C2;
}
`, "",{"version":3,"sources":["webpack://./src/components/KnowledgeBase/ArticlePage/ArticleFiles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,eAAe;EACf,iBAAiB;;EAEjB,qBAAqB;;EAErB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB","sourcesContent":[".files {\n  margin: 8px 0 20px;\n  padding: 0 20px;\n  color: #262732;\n}\n\n.filesTitle {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 140%;\n}\n\n.fileLinkWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  margin-top: 8px;\n  padding: 8px 16px;\n\n  text-decoration: none;\n\n  background: #EDEFF3;\n  border-radius: 8px;\n}\n\n.fileLinkWrapper:hover {\n  background: #E5E7F1;\n}\n\n.fileLinkWrapper:active {\n  background: #DADFF1;\n}\n\n.fileLinkWrapper img {\n  width: 16px;\n  height: 16px;\n}\n\n.file {\n  display: flex;\n  gap: 4px;\n}\n\n.fileName, .fileSize {\n  font-size: 13px;\n}\n\n.fileName {\n  color: #262732;\n}\n\n.fileSize {\n  min-width: fit-content;\n  color: #A7B1C2;\n}\n"],"sourceRoot":""}]);
// Exports
export var files = `files__HJIGD`;
export var filesTitle = `filesTitle__oFUgb`;
export var fileLinkWrapper = `fileLinkWrapper__cRpQe`;
export var file = `file__TtIaQ`;
export var fileName = `fileName__PWkJl`;
export var fileSize = `fileSize__NiUsy`;
export default ___CSS_LOADER_EXPORT___;
